import * as React from 'react';

import { ProviderProps as Props } from './types';

const Provider: React.FC<Props> = ({ children }) => {
  return <>{children}</>;
};

export default Provider;
